import './LinkLibrary.scss';

import React, { FunctionComponent } from 'react';

import { DonationLinkContextProvider } from '../../context/donationLinkContext';
import { Link } from 'react-router-dom';
import LinkLibraryDonationLinks from '../../components/LinkLibraryDonationLinks/LinkLibraryDonationLinks';
import { LinkLibrarySubHeading } from '../../components/LinkLibrarySubHeading/LinkLibrarySubHeading';
import { LinkLibraryTotals } from '../../components/LinkLibraryTotals/LinkLibraryTotals';
import { PAGES } from '../../constants/pages';
import { useChrome } from '../../hooks/useChrome';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useTranslation } from 'react-i18next';

export const LinkLibrary: FunctionComponent = () => {
  const { t } = useTranslation();
  useChrome();
  useDocumentTitle(t('linkLibrary.heading'));

  return (
    <main>
      <div className="linkLibrary__headerWrapper">
        <div className="container jg-space-pvmd jg-space-phms linkLibrary__headerContent">
          <div className="linkLibrary__headerText">
            <h1>{t('linkLibrary.heading')}</h1>
            <p className="linkLibrary__description">
              {t('linkLibrary.description')}
            </p>
          </div>
          <Link
            to={PAGES.Frequency}
            data-track="setup-checkout-continue"
            className="jg-btn jg-btn--secondary linkLibrary__createNewButton"
          >
            {t('linkLibrary.createNew')}
          </Link>
        </div>
      </div>
      <div className="container jg-space-pvlg jg-space-phms">
        <LinkLibrarySubHeading />
        <LinkLibraryTotals />
        <DonationLinkContextProvider>
          <LinkLibraryDonationLinks />
        </DonationLinkContextProvider>
      </div>
    </main>
  );
};
